import { Pipe, PipeTransform } from '@angular/core';
import { ImageService } from '../services/image.service';

@Pipe({
  name: 'convertImageToUrl',
  pure: true,
  standalone: true,
})
export class ConvertImageToUrlPipe implements PipeTransform {
  constructor(private imageService: ImageService) {}

  transform(value: any): any {
    return this.imageService.ConvertImageToURL(value);
  }
}
